import {
    CheckboxProps,
    FlexProps
} from '@chakra-ui/react';
import { CSSProperties, ReactNode } from 'react';

export enum GridCheckboxesVariants {
    studentCheckbox = 'studentCheckbox',
    topicCheckbox = 'topicCheckbox',
    activityCheckbox = 'activityCheckbox',
    assignedCheckbox = 'assignedCheckbox',
    dokCheckbox = 'dokCheckbox',
    cardViewBodyCheckbox = 'cardViewBodyCheckbox',
    circleCheckbox = 'circleCheckbox',
	overviewCheckbox = 'overviewCheckbox'
}

export type GridCheckboxProps = {
    checkboxProps: CheckboxProps
    styleProps?: FlexProps
    inputStyleProps?: CSSProperties
    showTooltipOnDisabled?: boolean
    tooltipLabel?: string
    disabledContent?: ReactNode
};
